import React, { useState } from "react";
import { useQuery } from 'react-query'

import { healthCheckApis } from "~/api";
import { HealthCheckResponse, STATUS_COLORS, checkNameMap } from "~/models";
import { useAppSelector } from '~/app/hooks'
import { isDarkTheme } from '~/redux/features'


// Tooltip rendering
const formatTooltip = (results: HealthCheckResponse["results"],isDark:boolean) => (
    <div style={{ padding: 10 }}>
        {Object.entries(results).map(([key, val]) => {
            // Use dictionary mapping if available, otherwise show the original key as-is
            const displayKey = checkNameMap[key] || key;
            const color = isDark ? "#fff" : "#222";
            return (
                <div key={key} style={{ marginBottom: 8 }}>
                    <strong style={{ color: color}}>{displayKey}:</strong>&nbsp;
                    <span style={{ color: STATUS_COLORS[val.status], fontWeight: "bold" }}>
                        {val.status}
                    </span>
                    {val.description && (
                        <div style={{ fontSize: 12, color: color, marginTop: 2 }}>
                            {val.description}
                        </div>
                    )}
                </div>
            );
        })}
    </div>
);
const lightTooltipStyle = {
    background: "#fff",
    border: "1px solid #ddd",
    boxShadow: "0 4px 18px rgba(0,0,0,0.15)",
};

const darkTooltipStyle = {
    background: "#23292f",
    border: "1px solid #444",
    boxShadow: "0 4px 18px rgba(0,0,0,0.9)",
};

export const HealthStatusIcon: React.FC = () => {
    const [hover, setHover] = useState(false);
    const isDark = useAppSelector(isDarkTheme);

    const { data: health, error } = useQuery<HealthCheckResponse, Error>(
        ["healthStatus"],
        () => healthCheckApis.getHealthCheck(), {
        onError(error) {
            console.error("Error fetching health data:", error);
        }
    })

    if (error || !health) {
        return (
            <div style={{ color: STATUS_COLORS.Unhealthy, fontWeight: "bold" }}>
            </div>
        );
    }

    const color = STATUS_COLORS[health.status];
    const themeStyle = isDark ? darkTooltipStyle : lightTooltipStyle;
    return (
        <div style={{ position: "relative", display: "inline-block" }}>
            <div
                style={{
                    width: 30,
                    height: 30,
                    borderRadius: "50%",
                    background: color,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                    cursor: "pointer",
                    transition: "background 0.2s",
                }}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                aria-label={`Overall Status: ${health.status}`}
            >
                <span style={{ fontSize: 22, color: "#fff" }}>
                </span>
            </div>

            {hover && (
                <div
                    style={{
                        position: "absolute",
                        top: "45px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        color: "#222",
                        borderRadius: 5,
                        zIndex: 999,
                        minWidth: 280,
                        maxWidth: 400,
                        fontSize: 14,
                        ...themeStyle
                    }}
                >
                    {formatTooltip(health.results,isDark)}
                </div>
            )}
        </div>
    );
};

